"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.US_TERRITORIES_COUNTRY_CODES = exports.US_COUNTRY_CODES = void 0;
require("core-js/modules/es6.array.fill.js");
require("core-js/modules/es6.function.name.js");
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _useDebounce = require("use-debounce");
var _reactPopper = require("react-popper");
var _currency = require("@nerdwallet/currency");
var _googleMapsApi = require("@nerdwallet/google-maps-api");
var _googleMapsAutocompleteModule = _interopRequireDefault(require("./google-maps-autocomplete.module.css"));
// @ts-nocheck - file causes errors when used in repos with strict typescript enabled

var US_TERRITORIES_COUNTRY_CODES = ['AS',
// American Samoa
'FM',
// Federated States of Micronesia
'GU',
// Guam
'MH',
// Marshall Islands
'MP',
// Northern Mariana Islands
'PW',
// Palau
'PR',
// Puerto Rico
'VI' // Virgin Islands, U.S.
];

// US Territories come in as country codes
// Filter by country (max 5 - defined by Google)
exports.US_TERRITORIES_COUNTRY_CODES = US_TERRITORIES_COUNTRY_CODES;
var US_COUNTRY_CODES = ['US', 'PR', 'VI', 'GU', 'MP'];

/** Type alias for the type of our suggestions. */

/**
 * Google API Suggestions.
 */
exports.US_COUNTRY_CODES = US_COUNTRY_CODES;
var useAutocompleteApi = function useAutocompleteApi(attributionsRef) {
  var api = (0, _googleMapsApi.useGoogleMapsPlacesApi)();
  var _React$useState = _react.default.useState(undefined),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    sessionToken = _React$useState2[0],
    setSessionToken = _React$useState2[1];
  var _React$useState3 = _react.default.useState(undefined),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    autocompleteService = _React$useState4[0],
    setAutocompleteService = _React$useState4[1];
  var _React$useState5 = _react.default.useState(),
    _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
    placesService = _React$useState6[0],
    setPlacesService = _React$useState6[1];
  _react.default.useEffect(function () {
    if (api) {
      setSessionToken(new api.AutocompleteSessionToken());
      setAutocompleteService(new api.AutocompleteService());
      setPlacesService(new api.PlacesService(attributionsRef));
    }
  }, [api, attributionsRef]);
  return {
    autocompleteService: autocompleteService,
    placesService: placesService,
    sessionToken: sessionToken
  };
};
var getSuggestionValue = function getSuggestionValue(suggestion) {
  return suggestion.description;
};
var InlineBoldText = function InlineBoldText(props) {
  return /*#__PURE__*/_react.default.createElement(_currency.Body, (0, _extends2.default)({
    inline: true,
    bold: true
  }, props));
};
var renderStringWithFormattedSubstrings = function renderStringWithFormattedSubstrings(str, substrings, FormattedComponent) {
  if (!str) {
    return '';
  }
  // Turn our offsets into an array representation so we can determine in
  // constant time if a substring is a match or not.
  var stringMap = new Array(str.length).fill(0);
  substrings === null || substrings === void 0 ? void 0 : substrings.forEach(function (substring) {
    for (var i = 0; i < substring.length; i += 1) {
      stringMap[substring.offset + i] = 1;
    }
  });
  var output = [];
  var current = '';
  var prevIsBold = false;
  for (var i = 0; i < str.length; i += 1) {
    var isBold = stringMap[i] === 1;
    if (isBold !== prevIsBold && current.length > 0) {
      // Commit current substring to output with appropriate formatting
      output.push(prevIsBold ? /*#__PURE__*/_react.default.createElement(FormattedComponent, {
        key: "".concat(i, "-").concat(current)
      }, current) : current);
      current = '';
    }
    current += str[i];
    prevIsBold = isBold;
  }
  if (current.length > 0) {
    // Commit the final substring to output with appropriate formatting
    output.push(prevIsBold ? /*#__PURE__*/_react.default.createElement(FormattedComponent, {
      key: "".concat(current.length, "-").concat(current)
    }, current) : current);
  }
  return output;
};
var renderSuggestion = function renderSuggestion(suggestion) {
  var _suggestion$structure = suggestion.structured_formatting,
    mainText = _suggestion$structure.main_text,
    mainTextMatchedSubstrings = _suggestion$structure.main_text_matched_substrings,
    secondaryText = _suggestion$structure.secondary_text;
  var formattedMainText = renderStringWithFormattedSubstrings(mainText, mainTextMatchedSubstrings, InlineBoldText);
  return /*#__PURE__*/_react.default.createElement(_currency.Cluster, {
    spacing: 1,
    alignY: "center"
  }, /*#__PURE__*/_react.default.createElement(_currency.Body, {
    inline: true
  }, formattedMainText), /*#__PURE__*/_react.default.createElement(_currency.Body, {
    inline: true,
    light: true,
    size: "small"
  }, secondaryText));
};
var GoogleMapsAutocomplete = function GoogleMapsAutocomplete(_ref) {
  var autocompleteOptions = _ref.autocompleteOptions,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    enableAutoFocus = _ref.enableAutoFocus,
    enableSelectOnEnter = _ref.enableSelectOnEnter,
    help = _ref.help,
    helpMessage = _ref.helpMessage,
    icon = _ref.icon,
    label = _ref.label,
    name = _ref.name,
    placeholder = _ref.placeholder,
    onBlur = _ref.onBlur,
    _onChange = _ref.onChange,
    _onFocus = _ref.onFocus,
    onSelect = _ref.onSelect,
    onSuggestionsChanged = _ref.onSuggestionsChanged,
    value = _ref.value;
  var attributionsRef = _react.default.useRef();
  var _React$useState7 = _react.default.useState({
      suggestionList: [],
      suggestionsCleared: true
    }),
    _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
    suggestions = _React$useState8[0],
    setSuggestions = _React$useState8[1];
  var suggestionList = suggestions.suggestionList,
    suggestionsCleared = suggestions.suggestionsCleared;
  var suggestionPlainList = JSON.stringify(suggestionList);
  _react.default.useEffect(function () {
    // Executing `onSuggestionsChanged` callback when there is an entered value and `suggestionList` hasn't been cleared.
    if (!suggestionsCleared && onSuggestionsChanged) {
      console.log(JSON.stringify(suggestionList));
      onSuggestionsChanged(suggestionList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestionPlainList, suggestionsCleared]);
  var _useAutocompleteApi = useAutocompleteApi(attributionsRef.current),
    autocompleteService = _useAutocompleteApi.autocompleteService,
    placesService = _useAutocompleteApi.placesService,
    sessionToken = _useAutocompleteApi.sessionToken;
  var loadSuggestions = (0, _useDebounce.useDebouncedCallback)(function (currentValue) {
    if (!autocompleteService || !sessionToken) return;
    var request = (0, _objectSpread2.default)({
      input: currentValue,
      componentRestrictions: {
        country: US_COUNTRY_CODES
      },
      sessionToken: sessionToken
    }, autocompleteOptions);
    autocompleteService.getPlacePredictions(request, function (results) {
      setSuggestions({
        suggestionList: results || [],
        suggestionsCleared: false
      });
    });
  }, 300, {
    // Ensure we fire this on the first keystroke
    leading: true,
    // Ensure we fire on the trailing edge of invocations
    trailing: true,
    // Don't ever allow more than 300ms to elapse between subsequent invocations
    maxWait: 300
  });
  var onSuggestionSelected = function onSuggestionSelected(event, _ref2) {
    var suggestion = _ref2.suggestion;
    var request = {
      placeId: suggestion.place_id,
      // Include as many fields as are needed for our use cases, but avoid
      // adding unnecessary fields because Google bills more for certain data.
      // https://developers.google.com/maps/billing/gmp-billing#places-product
      fields: ['address_components', 'geometry', 'formatted_address'],
      sessionToken: sessionToken
    };
    placesService.getDetails(request, function (result, status) {
      onSelect(result, status);
    });
  };

  // We use popper.js to position the dropdown. It needs references to the
  // input element and the suggestions dropdown container element to measure
  // and position things.
  //
  // We use callback refs + `useState` instead of `useRef` here so that the
  // component re-renders with the references as soon as they're set.
  var _React$useState9 = _react.default.useState(null),
    _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
    inputElement = _React$useState10[0],
    setInputElement = _React$useState10[1];
  var _React$useState11 = _react.default.useState(null),
    _React$useState12 = (0, _slicedToArray2.default)(_React$useState11, 2),
    containerElement = _React$useState12[0],
    setContainerElement = _React$useState12[1];
  var _usePopper = (0, _reactPopper.usePopper)(inputElement, containerElement),
    popperStyles = _usePopper.styles,
    popperAttributes = _usePopper.attributes,
    popperForceUpdate = _usePopper.forceUpdate;
  var renderInputComponent = _react.default.useCallback(function (props) {
    return /*#__PURE__*/_react.default.createElement(_currency.Input, (0, _extends2.default)({}, props, {
      // <Input>-specific props
      fullWidth: true,
      error: error,
      errorMessage: errorMessage,
      helpMessage: helpMessage || help,
      icon: icon,
      label: label
    }));
  }, [error, errorMessage, helpMessage, help, icon, label]);
  var renderSuggestionsContainer = function renderSuggestionsContainer(_ref3) {
    var containerProps = _ref3.containerProps,
      children = _ref3.children;
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, containerProps, {
      style: popperStyles.popper
    }, popperAttributes.popper, {
      ref: function ref(element) {
        if (element) {
          containerProps.ref(element);
          if (containerElement !== element) {
            setContainerElement(element);
          }
        }
      }
    }), children, /*#__PURE__*/_react.default.createElement("div", {
      className: _googleMapsAutocompleteModule.default.poweredByGoogleContainer
    }, /*#__PURE__*/_react.default.createElement("img", {
      alt: "Powered by Google",
      src: "https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3_hdpi.png",
      width: 128,
      height: 16
    })), /*#__PURE__*/_react.default.createElement("div", {
      ref: attributionsRef
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, {
    suggestions: suggestionList,
    onSuggestionsFetchRequested: function onSuggestionsFetchRequested(_ref4) {
      var currentValue = _ref4.value;
      return loadSuggestions.callback(currentValue);
    },
    onSuggestionsClearRequested: function onSuggestionsClearRequested() {
      setSuggestions({
        suggestionList: [],
        suggestionsCleared: true
      });
    },
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: renderSuggestion,
    renderInputComponent: renderInputComponent,
    renderSuggestionsContainer: renderSuggestionsContainer
    /**
     * Historically, `enableSelectOnEnter` behaved slightly differently - it
     * would cause the "Enter" key to populate the input with the first
     * suggestion, but the first suggestion itself wouldn't visually appear
     * as selected. The `highlightFirstSuggestion` prop keeps the first
     * suggestion highlighted, and still populates the input with that first
     * suggestion when "Enter" is pressed.
     *
     * TL;DR the only difference between this implementation and the old
     * implementation is that the new implementation shows a visual indicator
     * that the first element is selected if the `enableSelectOnEnter` prop
     * is used.
     */,
    highlightFirstSuggestion: enableSelectOnEnter,
    theme: _googleMapsAutocompleteModule.default,
    onSuggestionSelected: onSuggestionSelected
    /**
     * inputProps are passed directly to `renderInputComponent`. Autosuggest's docs say that
     * it must contain `value` and `onChange`. The rest will be passed directly to the input.
     *
     * Surprisingly, inputProps passes additional default props to the input, such as
     * aria-*, autoComplete, on*, style, and type.
     *
     * Be careful that your custom props in `renderInputComponent` don't get overridden by these fields.
     */,
    inputProps: {
      autoFocus: enableAutoFocus,
      onBlur: onBlur,
      onChange: function onChange(event, _ref5) {
        var newValue = _ref5.newValue;
        return _onChange(newValue);
      },
      /**
       * When the input receives focus, synchronously recompute the position
       * of the dropdown. This is necessary to handle our hot reload
       * development environment where styles are loaded asynchronously.
       * Popper.js won't know that the page reflowed, so we force it to measure
       * again to correctly position the dropdown.
       */
      onFocus: function onFocus(e) {
        popperForceUpdate === null || popperForceUpdate === void 0 ? void 0 : popperForceUpdate();
        _onFocus === null || _onFocus === void 0 ? void 0 : _onFocus(e);
      },
      name: name,
      placeholder: placeholder,
      ref: setInputElement,
      value: value
    }
  });
};
var _default = GoogleMapsAutocomplete;
exports.default = _default;